/**
 * /tenants/$slug/locked-out-users — the user-recovery desk, homed under People.
 *
 * Named for its subject. It was a tab of Identity governance,
 * where the B2C walkthrough went to the wrong "requests" queue for a
 * locked-out shopper. The old path redirects here.
 */

import { createFileRoute } from "@tanstack/react-router";

import { AdminRecoveryPage } from "@/features/admin-recovery/pages/admin-recovery-page";
import { fetchPendingRecoveryRequests } from "@/features/admin-recovery/queries";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/locked-out-users/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.adminRecovery.pending(context.tenant.id),
      queryFn: () => fetchPendingRecoveryRequests(context.tenant.id),
    }),
  component: AdminRecoveryPage,
});
